import { render, staticRenderFns } from "./NewsBanners.vue?vue&type=template&id=d45cf460&scoped=true&"
import script from "./NewsBanners.vue?vue&type=script&lang=ts&"
export * from "./NewsBanners.vue?vue&type=script&lang=ts&"
import style0 from "./NewsBanners.vue?vue&type=style&index=0&id=d45cf460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45cf460",
  null
  
)

export default component.exports